import styles from './ConsultPopup.module.css';

export default function ConsultantLogo({ className = '' }) {
  return (
    <div className={`${styles.consultantLogo} ${className}`}>
      <img src={`${process.env.NEXT_PUBLIC_CDN_PREFIX || ''}/logo_dark.png`} />
    </div>
  );
}
